var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuariosActivos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28 0L28 28L0 28L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-Tag-Icono"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28 0L28 28L0 28L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4635 1.74977C7.26221 1.77777 4.66667 4.3841 4.66667 7.58311C4.66667 10.7821 7.26279 13.3884 10.4635 13.4164L10.484 13.4164L10.5159 13.4164L10.5365 13.4164C13.7378 13.3884 16.3333 10.7821 16.3333 7.58311C16.3333 4.3841 13.7378 1.77777 10.5365 1.74977C10.5248 1.74977 10.5122 1.75035 10.5 1.74977C10.4872 1.74977 10.4758 1.74919 10.4635 1.74977L10.4635 1.74977ZM21.8647 13.9998C21.4529 13.9998 21.0655 14.1599 20.7744 14.4509L14.4512 20.7753C13.8498 21.3767 13.8498 22.3546 14.4512 22.956L17.8771 26.3819C18.1682 26.673 18.5556 26.8331 18.9674 26.8331C19.3793 26.8331 19.7667 26.673 20.0578 26.3819L26.3822 20.0576C26.6732 19.7665 26.8333 19.3785 26.8333 18.9672L26.8333 15.1995C26.8333 14.538 26.2951 13.9998 25.6336 13.9998L21.8647 13.9998L21.8647 13.9998ZM3.92155 15.7498C2.72455 15.7498 1.75 16.7907 1.75 18.0706L1.75 18.9581C1.75 20.872 2.73898 22.5353 4.53564 23.6407C6.04706 24.5711 8.06166 25.0831 10.2083 25.0831C11.6562 25.0831 13.0402 24.845 14.2541 24.4075L13.6263 23.7797C13.1147 23.2693 12.8333 22.5896 12.8333 21.8657C12.8333 21.1417 13.1147 20.4615 13.6263 19.9505L17.533 16.0449C17.2233 15.8629 16.8725 15.7498 16.4951 15.7498L3.92155 15.7498L3.92155 15.7498ZM23.625 16.3331C24.108 16.3331 24.5 16.7245 24.5 17.2081C24.5 17.6911 24.108 18.0831 23.625 18.0831C23.142 18.0831 22.75 17.6911 22.75 17.2081C22.75 16.7245 23.142 16.3331 23.625 16.3331L23.625 16.3331Z",
    id: "Forma",
    fill: "#304278",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuariosActivos);
export default __webpack_public_path__ + "static/media/usuarios_activos.3419ce5005b407f9e7d08d94e06ea00c.svg";
export { ForwardRef as ReactComponent };